import type { ResourceReportingConfig } from '../interfaces/ResourceReportingConfig';
import { REPORTING_TRANSPORTS } from './REPORTING_TRANSPORTS';

/**
 * @group Constants

@summary
<blockquote>Default reporting configuration for all environments</blockquote>

@remarks
Provides unified default reporting configuration that combines the best settings
from development, preview, and production environments.

@example
```typescript
const config = getResourceConfig('module.dashboard.data.page');
const reporting = config?.reporting ?? DEFAULT_REPORTING_CONFIG;
```
 * @internal
 */
export const DEFAULT_REPORTING_CONFIG: ResourceReportingConfig = {
  development: {
    transport: REPORTING_TRANSPORTS.CONSOLE,
    samplingRate: 1.0,
    consoleFormat: 'json'
  },
  preview: {
    transport: REPORTING_TRANSPORTS.POSTHOG,
    samplingRate: 1.0,
  },
  production: {
    transport: REPORTING_TRANSPORTS.POSTHOG,
    samplingRate: 1.0
  },
};